import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgLimitsRoutesN(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 -4 16 24" {...props}>
      <path
        d="M17 0a2 2 0 11-1.732 3.001L8 3c-1.1 0-2 .9-2 2s.9 2 2 2h8c2.21 0 4 1.79 4 4s-1.79 4-4 4l-7.268.001a2 2 0 110-2.001H16c1.1 0 2-.9 2-2s-.9-2-2-2H8C5.79 9 4 7.21 4 5s1.79-4 4-4h7.268A2 2 0 0117 0z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('LimitsRoutesN')(SvgLimitsRoutesN);
